import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Icon } from '../../../concepts/resources/Icon';
import { Position } from '../../../ui/Position';
import { Slider } from '../../../ui/Slider';
import { Tip } from '../../../ui/Tip';
import { useResolve } from '../../Container';
import { Box, Colors, Float } from './../../../ui';
import { ReplayController } from './ReplayController';
import { ReplayPlayback } from './ReplayPlayback';

const ActionButton = styled.div<{ side: 'left' | 'right' }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    color: ${Colors.primary};
    cursor: pointer;
    
    ${p => p.side === 'left'
        ? `border-right: solid 0.0625rem ${Colors.border};`
        : `border-left: solid 0.0625rem ${Colors.border};`}

    &:hover {
        background: ${Colors.hover};
    }
    &:active {
        background: ${Colors.active};
    }

`;

export const ReplayControlView = () => {

    const dispatch = useResolve(CommandDispatcher);
    const replay = useResolve(ReplayController);
    const playback = useMemo(() => new ReplayPlayback(replay), [replay]);
    const { playing } = useObserver(playback);
    const minMax = [0, replay.getLength()];
    const [position, setPosition] = useState(replay.getPosition());

    useEffect(() => replay.on('position', setPosition), []);

    const onPlay = useCallback(() => playback.play(), [playback]);
    const onStop = useCallback(() => playback.stop(), [playback]);
    const onClose = useCallback(() => dispatch('exit'), []);

    return <Position at="bottom" inset="1">
        <Float inline>
            <Box flex="row">
                {!playing &&
                    <Tip text="Play/Stop" position="top">
                        <ActionButton side="left" onClick={onPlay}>
                            <Icon size="1.5" src="deqo://icons/i8/play-fill" />
                        </ActionButton>
                    </Tip>
                }
                {playing &&
                    <Tip text="Play/Stop" position="top">
                        <ActionButton side="left" onClick={onStop}>
                            <Icon size="1.5" src="deqo://icons/i8/stop-fill" />
                        </ActionButton>
                    </Tip>
                }
                <Box width="48" padding=".75">
                    <Slider
                        min={minMax[0]}
                        max={minMax[1]}
                        value={position}
                        onChange={x => replay.setPosition(x)}
                    />
                </Box>
                <Tip text="Close (Esc)" position="top">
                    <ActionButton side="right" onClick={onClose}>
                        <Icon size="1.5" src="deqo://icons/hero/x" />
                    </ActionButton>
                </Tip>
            </Box>
        </Float>
    </Position>;
};
